import { render, staticRenderFns } from "./BasicMobileFullModal.vue?vue&type=template&id=fb1cb1cc&"
import script from "./BasicMobileFullModal.vue?vue&type=script&lang=ts&"
export * from "./BasicMobileFullModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports